function getHeaders(token: string) {
	return {
		Accept: "application/json",
		"Content-Type": "application/json",
		'showrooms-token': token
	};
}

export const RefreshShowroomsTokens = (tokensJWT: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/showrooms/refreshTokens`, {
		method: 'POST',
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			"showrooms-token": tokensJWT
		}
	}).then(result => {
		if (result.ok) {
			let json = result.json();
			return json;
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/events status ${result.status}`);
		}
	}).catch(error => {
		console.error(error);
	});
}

export const LoadSessions = (accessToken: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/showrooms/sessions`, {
		method: 'GET',
		headers: getHeaders(accessToken)
	}).then(result => {
		if (result.ok) {
			let json = result.json();
			return json;
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/events status ${result.status}`);
		}
	}).catch(e => console.log(e));
}
